// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("LuckyTilesPick", {
  id: __t.u64(),
  userId: __t.u64(),
  boardId: __t.u64(),
  tileIndex: __t.u32(),
  rewardType: __t.string(),
  rewardAmount: __t.i64(),
  wasFree: __t.bool(),
  pickedAt: __t.u64(),
});


